export enum DictionaryNamesEnum {
  PERMIT_DOCS = 'permit_docs',
  ACCEPTED_DOCUMENT = 'accepted_document',
  CHECKLIST = 'checklist',
  EVENT_TYPE = 'event_type',
  PM_PROF_EVENT_TYPE = 'pm_prof_event_type',
  KNM_KIND = 'knm_kind',
  DECISION_KIND = 'decision_kind',
  DECISION_KIND_ALL = 'decision_kind_all',
  KNO_ORGANIZATIONS = 'kno_organizations',
  POSITIONS = 'positions',
  PROF_KIND = 'prof_kind',
  REQUIREMENT = 'requirement',
  RISK_CATEGORY = 'risk_category',
  RISK_INDICATORY = 'risk_indicatory',
  SUBJECT_KIND = 'subject_kind',
  SUBJECT_SUB_KIND = 'subject_sub_kind',
  APPLICATION_CONDITION_SUBJECTS = 'application_condition_subjects',
  SUBJECT_TYPE = 'subject_type',
  SUPERVISION_TYPE = 'supervision_type',
  FEDERAL_LAWS = 'federal_laws',
  KNO_LEVELS = 'kno_levels',
  KNM_SUBJECT_TYPES = 'knm_subject_types',
  DANGER_CLASS = 'danger_class',
  PARTICIPANT_POSITIONS = 'participant_positions',
  TARGET_ENTITY = 'target_entity',
  TARGET_ENTITY_FOUNDER = 'target_entity_founder',
  KNM_TYPES = 'knm_type',
  ERVK = 'ervk',
  ERVK_CHECK_LIST = 'ervk_check_list',
  CONDITION_TYPES = 'condition_types',
  SUPERVISION_TYPE_BY_SUBJECT_TYPE = 'supervision_type_by_subject_type',
}
